import React from 'react';

export default function RegisterOverlay(){
    return (
        <div className="absolute inset-0 bg-base-100/90 z-50 flex justify-center">
            <div className="card-body justify-space-around items-center pt-[70px]">
                <h2 className="md:w-9/12 text-xl font-semibold text-center">Register to watch all episodes <br className="hidden md:block" />AND get a free sermon CD!</h2>
                <div className='card-actions text-center mt-4'>
                    <a href="/register?source=plus&new=true#login" className="btn btn-primary m-auto">Register</a>
                    <a href="#login" className="btn btn-outline m-auto">Log In</a>
                </div>
            </div>
        </div>
    )
}